import { useLayoutEffect, useState } from "react";
import CustomCursor from "@/components/animatedComponents/CustomCursor";
import LightSpots from "@/components/animatedComponents/LightSpots";
import Navbar from "@/components/Navbar";
import WebServicesPromo from "@/components/WebServicesPromo";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const WebServices = () => {
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    ScrollSmoother.get()?.kill();
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const frame = window.requestAnimationFrame(() => setIsReady(true));

    return () => window.cancelAnimationFrame(frame);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#0d1821] text-[#f5f5f5]">
      <CustomCursor />
      <LightSpots />
      <div className="relative z-10">
        <Navbar />
        <main className="pt-0">
          {isReady && <WebServicesPromo />}
        </main>
      </div>
    </div>
  );
};

export default WebServices;
